import React, {useState, useEffect} from "react";
import './navbar.scss'
import {GiHamburgerMenu} from 'react-icons/gi'
import logo from '../../assets/navbar/Looogo.png'
import Telegram from '../../assets/navbar/icons8-telegram-app (2).svg'
// import YouTube from '../../assets/navbar/icons8-youtube.svg'
import Instagram from '../../assets/navbar/icons8-instagram (3).svg'
import Call from '../../assets/navbar/call-center-service (1).png'
import Location from '../../assets/navbar/location.png'
import {Link} from "react-router-dom";


const Navbar = () => {
    const [showMediaIcons, setShowMediaIcons] = useState(false);
    const [fix, setFix] = useState(false)

    function setFixed() {
        if (window.scrollY >= 10) {
            setFix(true)
        } else {
            setFix(false)
        }
    }

    window.addEventListener("scroll", setFixed)

    return (
        <>
            <nav className="main-nav fixed">
                <div className="logo">
                    <a href="/">
                        <img src={logo} alt=""/>
                    </a>
                </div>
                <div className={showMediaIcons ? "menu-link mobile-menu-link" : "menu-link"
                }>
                    <ul>
                        <li><Link to="/menu">Меню</Link></li>
                        <li>
                            <a target={'_blank'} href="tel:+998950300003">
                                Call-centre
                                {/*<img src={Call} alt=""/>*/}
                            </a>
                        </li>
                        <li>
                            <a target={'_blank'} href="https://goo.gl/maps/PvY8mMbAKHpuBwXv9">
                                Локация
                                {/*<img src={Location} alt=""/>*/}
                            </a>
                        </li>

                        {/*<li onClick={() => setShowMediaIcons(p => !p)}><a href="#statistikalar">Статистика</a></li>*/}
                        {/*<li onClick={() => setShowMediaIcons(p => !p)}><a href="#taomlarimiz">Таомлар</a></li>*/}
                        {/*<li onClick={() => setShowMediaIcons(p => !p)}><a href="#rating">Рейтинг</a></li>*/}
                        {/*<li>*/}
                        {/*    <select className={'select'}>*/}
                        {/*        <option className={'option'} value="1">Uz</option>*/}
                        {/*        <option className={'option'} value="2">Ru</option>*/}
                        {/*    </select>*/}
                        {/*</li>*/}
                    </ul>
                </div>
                <div className="social-media">
                    <ul className={'social-media-desktop'}>
                        <li>
                            <a target={'_blank'} href="https://www.instagram.com/sofcafe.uz/">
                                <img src={Instagram} width={30} alt=""/>
                            </a>
                        </li>
                        <li>
                            <a target={'_blank'} href="https://t.me/sofcafe_bot">
                                <img src={Telegram} width={30} alt=""/>
                            </a>
                        </li>
                    </ul>
                    <div className={'hamburger-menu'}>
                        <div style={{cursor: 'pointer'}} onClick={() => setShowMediaIcons(p => !p)}>
                            <GiHamburgerMenu color={'#fff'}/>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;